import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './report-intro.component.scss';
var ReportIntro = /** @class */ (function (_super) {
    tslib_1.__extends(ReportIntro, _super);
    function ReportIntro(element) {
        return _super.call(this, element) || this;
    }
    ReportIntro.prototype.init = function () {
    };
    ReportIntro.prototype.bindEvents = function () {
    };
    return ReportIntro;
}(Base));
export { ReportIntro };



//////////////////
// WEBPACK FOOTER
// ./components/report-intro/report-intro.component.ts
// module id = 474
// module chunks = 0